import './index.scss'
import fullpage from 'fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'
import Swiper from 'swiper/dist/js/swiper.min.js'
import '../../assets/scripts/jquery.waypoints.min.js'
import '../../assets/scripts/jquery.countup.min.js'

// 产品轮播
var proswiper = new Swiper(".section1 .right-swiper .mySwiper", {
    slidesPerView: 2.5,
    spaceBetween: 60,
    navigation: {
      nextEl: ".section1 .right-swiper .swiper-button-next",
      prevEl: ".section1 .right-swiper .swiper-button-prev",
    },
    breakpoints: {
      1440: {
        slidesPerView: 2.5,
        spaceBetween: 50,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 30,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
  });